import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import i18n from "../i18n";

import FlowDriversInformationForm from "../components/FlowDriversInformationForm.jsx";
import FlowLeftSideAvatar from "../components/FlowLeftSideAvatar.jsx";

import useRouting from "../hooks/useRouting";
import { patchStorage, retrieveStorageById } from "../helpers/storeService";

const FlowDriversInformation = () => {
  const [defaultValues, setDefaultValues] = useState({});
  const { renderNextRoute } = useRouting();
  const { id, affinity, insuranceType } = useParams();
  const { data } = retrieveStorageById(id, affinity, insuranceType);

  const [additionalDrivers, setAdditionalDrivers] = useState([]);

  useEffect(() => {
    const { data } = retrieveStorageById(id, affinity, insuranceType);
    setDefaultValues(data);
  }, []);

  function handleSubmit(values) {
    if (additionalDrivers.length > 0) {
      patchStorage({
        payload: { car: { ...data?.car, mainDriver : { ...data?.car?.mainDriver, ...values }, additionalDrivers } },
        id,
        affinity,
        insuranceType,
      });
    } else {
      patchStorage({
        payload: { car: { ...data?.car, mainDriver : { ...data?.car?.mainDriver, ...values } } },
        id,
        affinity,
        insuranceType,
      });
    }
    renderNextRoute();
  }

  const handleAddedDrivers = (value) => {
    console.log(value);
    setAdditionalDrivers(value);
  };

  return (
    <SplitContainer>
      <FlowLeftSideAvatar
        chatText={i18n.t(
          `To start off, I will need the information about the main driver and possible additional drivers`
        )}
      />
      <RightSplit>
        <FlowDriversInformationForm
          handleAddedDrivers={handleAddedDrivers}
          handleFormValues={handleSubmit}
          defaultValues={
            insuranceType !== "home"
              ? defaultValues?.car?.mainDriver || {}
              : defaultValues
          }
        />
      </RightSplit>
    </SplitContainer>
  );
};

const SplitContainer = styled.div`
  display: flex;
  height: 100%;
`;

const RightSplit = styled.div`
  width: 50%;
  padding: 5rem 4rem;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100%;
  }

  @media screen and (max-width: 425px) {
    padding: 4rem 2.5rem;
  }
`;

export default FlowDriversInformation;
